import { render, staticRenderFns } from "./StockLevel.vue?vue&type=template&id=1e22f062&"
import script from "./StockLevel.vue?vue&type=script&lang=js&"
export * from "./StockLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../create-website/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports